import { render, staticRenderFns } from "./agbConsent.vue?vue&type=template&id=52fd6a8e&scoped=true"
import script from "./agbConsent.vue?vue&type=script&lang=js"
export * from "./agbConsent.vue?vue&type=script&lang=js"
import style0 from "./agbConsent.vue?vue&type=style&index=0&id=52fd6a8e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fd6a8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte\\Onlytonapoli\\onlytonapoliapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52fd6a8e')) {
      api.createRecord('52fd6a8e', component.options)
    } else {
      api.reload('52fd6a8e', component.options)
    }
    module.hot.accept("./agbConsent.vue?vue&type=template&id=52fd6a8e&scoped=true", function () {
      api.rerender('52fd6a8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/agbConsent.vue"
export default component.exports